var map = {
	"./cert-E-commerce-hkgcsmeaa.jpg": 269,
	"./cert-customer-hkgcsmeaa.jpg": 270,
	"./cert-finance-hkgcsmeaa.jpg": 272,
	"./cert-fsi-hkgcsmeaa.jpg": 274,
	"./cert-general-staff-a-hkgcsmeaa.jpg": 276,
	"./cert-general-staff-hkgcsmeaa.jpg": 278,
	"./cert-general2024-hkgcsmeaa.jpg": 208,
	"./cert-hr-hkgcsmeaa.jpg": 279,
	"./cert-it-hkgcsmeaa.jpg": 280,
	"./cert-market-hkgcsmeaa.jpg": 281,
	"./cert-ngo-hkgcsmeaa.jpg": 282,
	"./cert-senior-manager-hkgcsmeaa.jpg": 284,
	"./cert-startup-hkgcsmeaa.jpg": 285,
	"./cert-student-hkgcsmeaa.jpg": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2668;